// extracted by mini-css-extract-plugin
export default {"lineBox":"index_lineBox_N8Le4","lineDl":"index_lineDl_NiSvH","lineDt":"index_lineDt_LmQAB","lineDd":"index_lineDd_3P439","icon":"index_icon_AjwFi","line":"index_line_EWOc7"};